import { createSelector } from 'reselect';

const selectGlobalDBNPRegistrations = (state: any) => state.globalDBNPRegistrations;


export const selectGlobalDBNPRegistrationsCurrentItem = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.current);

export const selectGlobalDBNPRegistrationsListItems = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDBNPRegistrationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDBNPRegistrationsQueryItems = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.query);

export const selectGlobalDBNPRegistrationsCreatedItem = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.create);

export const selectGlobalDBNPRegistrationsUpdatedItem = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.update);

export const selectGlobalDBNPRegistrationsReadItem = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.read);

export const selectGlobalDBNPRegistrationsDeletedItem = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.delete);

export const selectGlobalDBNPRegistrationsSearchedItems = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.search);

export const selectGlobalDBNPRegistrationsItemsCount = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.count);

export const selectGlobalDBNPRegistrationsItemsFilter = createSelector([selectGlobalDBNPRegistrations], (globalDBNPRegistrations) => globalDBNPRegistrations.filter);